import { ElementData } from "../Data/ElementData";
import * as SFX from "../Data/SoundEffectKeys";

export class PowerupData extends ElementData {
    public readonly tint: number;
    public readonly vo: string[];

    constructor(pAsset: string, pTint: number, pVO: string[]) {
        super(pAsset, "", true, false);
        this.tint = pTint;
        this.vo = pVO;
    }
}
